module.exports = __webpack_public_path__ + "img/title-logo.deb701ad.webp";